/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTallymark2 = createReactComponent("outline", "tallymark-2", "IconTallymark2", [["path", { "d": "M10 5l0 14", "key": "svg-0" }], ["path", { "d": "M14 5l0 14", "key": "svg-1" }]]);

export { IconTallymark2 as default };
//# sourceMappingURL=IconTallymark2.mjs.map
